// extracted by mini-css-extract-plugin
module.exports = {"linkbox":"_3k0jL","bannerArea":"_1cthZ","bannerTitle":"_13DLh","bannerImg":"_1GfZX","imgContainer":"bRqre"};